import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Import styles
import { Item, LinkStyled } from './styles';

function FooterLink({ path, translation }) {
	const { t } = useTranslation();
	return (
		<Item>
			<LinkStyled to={path} as={Link}>
				{t(translation)}
			</LinkStyled>
		</Item>
	);
}

export default FooterLink;
